import React, {useEffect, useState} from "react";
import { makeStyles, ButtonBase, Typography } from "@material-ui/core";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import clsx from "clsx";
import { getLang } from "app/feature/constants";

const useStyle = makeStyles((theme) => ({
  root: {
    padding: "5px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    borderRadius: "4px",
    width: "100%",
    border: "1px solid #D0D5DD",
  },
  inputText: {
    fontSize: "1rem",
    color: "#A4A6A8",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  filled: {
    color: "rgba(0, 0, 0, 0.87)",
  },
}));

export default function RequestTransferBranchSelectComponent({
  anchorRef,
  handleClick,
  value,
  styles,
  disabled,
  textStyles,
  placeholder,
  lang,
  isFromFetching,
  isToFetching,
  type,
}) {
  const classes = useStyle();

  const [count, setCount] = useState(1);

  useEffect(() => {
    const timer = setInterval(() => {
      clearInterval(timer);

      if (count === 3) {
        setCount(1);
      }
      else {
        setCount(count + 1);
      }
    }, 1000);
  }, [count]);

  const getDisplay = () => {
    if (type === 'from' && isFromFetching)
      return getLang(lang, "label.LOADING_NO_DOT") + ".".repeat(count);

    if (type === 'to' && (isFromFetching || isToFetching))
      return getLang(lang, "label.LOADING_NO_DOT") + ".".repeat(count);

    let display = placeholder || getLang(lang, "placeholder.SELECT_A_BRANCH");
    if (value) {
      display = value.name;
    }
    return display;
  };

  return (
    <ButtonBase
      className={classes.root}
      disableRipple
      ref={anchorRef}
      style={styles}
      onClick={handleClick}
      disabled={disabled || isFromFetching || isToFetching}
    >
      <Typography
        variant="body2"
        style={textStyles}
        className={clsx(
          classes.inputText,
          value !== getLang(lang, "placeholder.SELECT_A_BRANCH") &&
          !(type === 'from' && isFromFetching) &&
          !(type === 'to' && (isFromFetching || isToFetching)) &&
          getDisplay() !== placeholder &&
            classes.filled
        )}
      >
        {getDisplay()}
      </Typography>
      <ArrowDropDownIcon fontSize="small" />
    </ButtonBase>
  );
}
